<form
  [formRoot]="form()"
  class="grid grid-cols-4 gap-2"
>
  <div class="md:col-span-3 col-span-4">
    <proffeo-ui-input
      [formField]="form().name"
      [matAutocomplete]="auto"
      label="company-projects.form-labels.project-name"
      autocomplete="off"
      class="w-full my-2"
    />

    <mat-autocomplete
      #auto="matAutocomplete"
      (optionSelected)="onExistingDraftProjectSelected($event)"
    >
      @for (draftProject of filteredDraftProjects() ?? []; track draftProject.id) {
        <mat-option
          [value]="draftProject"
          tabindex="0"
        >
          {{ draftProject.name }}
        </mat-option>
      }
    </mat-autocomplete>

    <proffeo-ui-textarea
      [formField]="form().description"
      [rows]="4"
      [autosize]="false"
      label="company-projects.form-labels.description"
      class="flex"
    />
  </div>

  <proffeo-project-avatar-image
    (inputChanged)="saveImage($event)"
    [formField]="form().avatarId"
    [projectName]=""
    class="md:col-span-1 col-span-4 flex"
  ></proffeo-project-avatar-image>
  <div class="flex flex-col items-center col-span-2 md:col-span-1">
    <proffeo-label class="flex gap-1">
      <span class="truncate">{{ 'company-projects.form-labels.supervisor' | translate }}</span>
    </proffeo-label>
    <proffeo-avatar
      (click)="openSelectProjectSupervisorDialog()"
      [size]="AvatarSize.MD"
      [user]="form().supervisor().value()"
      iconName="person"
      class="flex flex-col col-span-2 md:col-span-1 mt-2"
    ></proffeo-avatar>
  </div>

  <div class="col-span-2"></div>

  <proffeo-ui-date-picker
    [formField]="form().startDate"
    label="company-projects.form-labels.start-date"
    class="md:col-span-2 col-span-4 relative mt-2"
  />

  <proffeo-ui-date-picker
    [formField]="form().endDate"
    label="company-projects.form-labels.end-date"
    class="md:col-span-2 col-span-4 relative mt-2"
  />

  <div class="flex items-center md:col-span-2 col-span-4 relative mt-2">
    @let financial = form().estimation.financial;
    <proffeo-ui-input
      [formField]="financial.amount"
      label="company-projects.form-labels.financial-estimation"
      type="number"
      class="w-1/2"
    />
    <proffeo-ui-select
      [formField]="financial.currency"
      [options]="currencySelectOptions"
      [translateLabels]="false"
      label="company-projects.form-labels.currency"
      class="w-1/2"
    />
  </div>
  <div class="flex items-center md:col-span-2 col-span-4 mt-2">
    @let time = form().estimation.time;
    <proffeo-ui-input
      [formField]="time.amount"
      label="company-projects.form-labels.time-estimation"
      type="number"
      class="w-1/2"
    />
    <proffeo-ui-select
      [formField]="time.units"
      [options]="timeUnitsItems"
      [translateLabels]="false"
      label="company-projects.form-labels.time-unit"
      class="w-1/2"
    />
  </div>
  <proffeo-ui-input
    [formField]="form().address"
    label="company-projects.form-labels.address"
    class="col-span-4 mt-2"
  />
</form>
